<ng-template #starsTemplate let-rating="rating">
  <div class="rating-stars">
    <span
      *ngFor="let star of getStarsArray(rating)"
      class="star"
      [ngClass]="{ full: star === 1, half: star === 0.5, empty: star === 0 }"
      [style.--star-color]="starColor">
      ★
    </span>
  </div>
</ng-template>

<div class="dynamic-reviews-example" [ngClass]="{ 'is-mobile': isMobile }">
  <div class="checkout-skeleton">
    <div class="checkout-skeleton__header">
      <div class="checkout-skeleton__line checkout-skeleton__line--title"></div>
    </div>

    <div class="checkout-skeleton__products">
      <div class="checkout-skeleton__product" *ngFor="let product of sampleProducts">
        <div class="checkout-skeleton__product-image">
          <img src="assets/icons/checkout_content_default.png" alt="" />
        </div>
        <div class="checkout-skeleton__product-info">
          <div class="checkout-skeleton__product-name">{{ product.name }}</div>
          @if (product.variant) {
            <div class="checkout-skeleton__product-variant">{{ product.variant }}</div>
          }

          <ng-container [ngSwitch]="layoutStyle">
            <ng-container *ngSwitchCase="LayoutStyle.RATING_BADGE">
              <div class="rating-badge" [ngSwitch]="ratingBadgeType">
                <ng-container *ngSwitchCase="RatingBadgeType.STARS">
                  <ng-container *ngTemplateOutlet="starsTemplate; context: { rating: product.rating }"></ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="RatingBadgeType.NUMBER">
                  <div class="rating-number">
                    <span class="review-count">({{ product.reviewCount }} reviews)</span>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="RatingBadgeType.BOTH">
                  <div class="rating-both">
                    <ng-container *ngTemplateOutlet="starsTemplate; context: { rating: product.rating }"></ng-container>
                    <span class="review-count">({{ product.reviewCount }})</span>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div class="checkout-skeleton__product-price">
          <span>{{ product.price }}</span>
          <span class="checkout-skeleton__compare-price">{{ product.comparePrice }}</span>
        </div>
      </div>
    </div>

    <ng-container [ngSwitch]="layoutStyle">
      <ng-container *ngSwitchCase="LayoutStyle.REVIEW_CAROUSEL">
        @if (carouselDescription) {
          <div class="review-carousel" [ngClass]="{ 'review-carousel--scrollbar': isScrollbarNav }">
            @if (carouselTitle) {
              <div class="list-header">
                <span class="list-title">{{ carouselTitle }}</span>
              </div>
            }
            <div class="carousel-content">
              <div class="review-card" *ngFor="let review of visibleCarouselReviews" [ngStyle]="carouselCardStyles">
                @if (starPosition === StarPosition.TOP) {
                  <ng-container
                    *ngTemplateOutlet="starsTemplate; context: { rating: review.reviewStarRating }"></ng-container>
                }
                <div class="review-card-content" [innerHTML]="getRenderedCardContent(review) | safe: 'html'"></div>
                @if (starPosition === StarPosition.BOTTOM) {
                  <ng-container
                    *ngTemplateOutlet="starsTemplate; context: { rating: review.reviewStarRating }"></ng-container>
                }
              </div>
            </div>
            @if (!isScrollbarNav) {
              <div class="carousel-nav">
                <button class="nav-btn">
                  <pdq-icon icon="side_left_arrow" size="small"></pdq-icon>
                </button>
                <button class="nav-btn">
                  <pdq-icon icon="side_right_arrow" size="small"></pdq-icon>
                </button>
              </div>
            }
            @if (isScrollbarNav) {
              <div class="carousel-scrollbar">
                <div class="carousel-scrollbar-track">
                  <div class="carousel-scrollbar-thumb"></div>
                </div>
              </div>
            }
          </div>
        }
      </ng-container>

      <ng-container *ngSwitchCase="LayoutStyle.REVIEW_LIST">
        @if (listDescription) {
          <div class="review-list">
            @if (listTitle) {
              <div class="list-header">
                <span class="list-title">{{ listTitle }}</span>
              </div>
            }
            <div class="list-content">
              <div class="review-item" *ngFor="let review of paginatedListReviews" [ngStyle]="listItemStyles">
                <div class="review-item-row">
                  <div class="review-item-left">
                    <div class="review-card-content" [innerHTML]="getRenderedListContent(review) | safe: 'html'"></div>
                  </div>
                  <ng-container
                    *ngTemplateOutlet="starsTemplate; context: { rating: review.reviewStarRating }"></ng-container>
                </div>
              </div>
            </div>
            <div class="carousel-nav">
              <button class="nav-btn" (click)="listPagePrev()" [disabled]="listPage === 0">
                <pdq-icon icon="side_left_arrow" size="small"></pdq-icon>
              </button>
              <button class="nav-btn" (click)="listPageNext()" [disabled]="listPage >= totalListPages - 1">
                <pdq-icon icon="side_right_arrow" size="small"></pdq-icon>
              </button>
            </div>
          </div>
        }
      </ng-container>
    </ng-container>

    <div class="checkout-skeleton__divider"></div>

    <div class="checkout-skeleton__totals">
      <div class="checkout-skeleton__totals-row">
        <div class="checkout-skeleton__line checkout-skeleton__line--medium"></div>
        <div class="checkout-skeleton__line checkout-skeleton__line--price"></div>
      </div>
      <div class="checkout-skeleton__totals-row">
        <div class="checkout-skeleton__line checkout-skeleton__line--medium"></div>
        <div class="checkout-skeleton__line checkout-skeleton__line--price"></div>
      </div>
      <div class="checkout-skeleton__divider"></div>
      <div class="checkout-skeleton__totals-row">
        <div class="checkout-skeleton__line checkout-skeleton__line--medium"></div>
        <div class="checkout-skeleton__line checkout-skeleton__line--price-bold"></div>
      </div>
    </div>
  </div>
</div>
